"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _styledPx2rem = _interopRequireDefault(require("../../utils/styled-px2rem"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _excluded = ["className", "checked", "children", "disabled", "inputRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Icon = function Icon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "18",
    height: "18",
    rx: "4",
    fill: "#FF611D"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.847 4.346a.833.833 0 0 1 .138 1.17L8.41 13.85a.833.833 0 0 1-1.193.12l-4.089-3.46a.833.833 0 1 1 1.077-1.273l3.43 2.904 6.042-7.657a.833.833 0 0 1 1.17-.138z",
    fill: "#fff"
  }));
};
Icon.defaultProps = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var DEFAULT_OPTIONS = {
  enableUncheckOnDisabled: false
};
var Checkbox = /*#__PURE__*/function (_React$PureComponent) {
  function Checkbox() {
    (0, _classCallCheck2["default"])(this, Checkbox);
    return _callSuper(this, Checkbox, arguments);
  }
  (0, _inherits2["default"])(Checkbox, _React$PureComponent);
  return (0, _createClass2["default"])(Checkbox, [{
    key: "options",
    get: function get() {
      var options = this.props.options;
      return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
    }
  }, {
    key: "isCheckBoxDisabled",
    get: function get() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        checked = _this$props.checked;
      var enableUncheckOnDisabled = this.options.enableUncheckOnDisabled;
      return disabled && !(enableUncheckOnDisabled && checked);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        checked = _this$props2.checked,
        children = _this$props2.children,
        disabled = _this$props2.disabled,
        inputRef = _this$props2.inputRef,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var isDescribed = !!children;
      return /*#__PURE__*/_react["default"].createElement(StyledLabel, {
        className: className,
        disabled: disabled,
        checked: checked
      }, /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
        described: isDescribed
      }, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, (0, _extends2["default"])({}, props, {
        checked: checked,
        disabled: this.isCheckBoxDisabled,
        ref: inputRef
      })), checked && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
        disabled: disabled
      })), children);
    }
  }]);
}(_react["default"].PureComponent);
var StyledCheckbox = _styledPx2rem["default"].input.attrs({
  type: 'checkbox'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  pointer-events: auto;\n  cursor: pointer;\n  appearance: none;\n  display: block;\n  height: 18px;\n  width: 18px;\n  border: 0;\n  cursor: pointer;\n\n  &:after {\n    border: 1px solid var(--grey3);\n    border-radius: 4px;\n    box-sizing: border-box;\n    content: '';\n    display: block;\n    height: 100%;\n    width: 100%;\n  }\n\n  ", "\n"])), function (props) {
  return props.disabled && (0, _styledComponents.css)(["cursor:default;"]);
});
var StyledLabel = _styledPx2rem["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.disabled && (0, _styledComponents.css)(["cursor:unset;opacity:var(--disabled-opacity);"]);
});
var StyledWrapper = _styledPx2rem["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n"])));
var StyledIcon = (0, _styledPx2rem["default"])(Icon)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  left: 0px;\n  top: 0px;\n  position: absolute;\n  rect {\n    fill: var(--secondary);\n  }\n"])));
Checkbox.StyledWrapper = StyledWrapper;
Checkbox.propTypes = {
  checked: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].shape({
    enableUncheckOnDisabled: _propTypes["default"].bool
  }),
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].shape({})
  })])
};
Checkbox.defaultProps = {
  checked: false,
  children: '',
  className: '',
  disabled: false,
  onChange: Function.prototype,
  options: {},
  inputRef: null
};
var _default = exports["default"] = Checkbox;